import { jsx as t, jsxs as m } from "react/jsx-runtime";
import f from "./mdView/MdView.js";
import { memo as c, useCallback as u, useMemo as d } from "react";
import { u as h } from "./styled-components.browser.esm-3eb04950.js";
import { isEmpty as T } from "./utils/object.utils.js";
import { concatInformationLinkToText as C } from "./utils/utils.js";
import { IconContainer as x } from "./IconContainer.js";
import { useLanguageResolver as g } from "@biron-data/react-contexts";
import { TooltipContainer as v, TooltipAlias as y, TooltipContentElement as j, TooltipText as w } from "./themes/SharedStyledComponent.js";
const S = c(({
  Icon: l,
  title: s,
  description: o,
  viewLink: e,
  nature: n = "other"
}) => {
  const p = g(), r = u((i) => {
    switch (n) {
      case "view":
        return C(i, p, e);
      default:
        return i;
    }
  }, [n, e]), a = d(() => T(o) ? r() : typeof o == "string" ? o.trim() === "" ? void 0 : /* @__PURE__ */ t(f, { description: r(o), padding: 0 }) : /* @__PURE__ */ t(E, { children: o }), [o, r]);
  return /* @__PURE__ */ m(v, { children: [
    /* @__PURE__ */ m(y, { translate: "no", children: [
      /* @__PURE__ */ t(x, { size: 22, children: /* @__PURE__ */ t(l, {}) }),
      s
    ] }),
    /* @__PURE__ */ t(j, { children: /* @__PURE__ */ t(w, { children: a }) })
  ] });
}), E = h.div`
    line-height: 20px;
`;
export {
  S as TooltipContent
};
//# sourceMappingURL=TooltipContent.js.map
